import { InspectionTemplate } from '@sw-sw/lib-inspection-templates';
import React, { useState, useEffect } from 'react';
import inspectionTemplateApi from '../../utils/api/inspectionTemplate';
import inspectionTemplateTypesApi, { InspectionTemplateType } from '../../utils/api/inspectionTemplateTypes';
import ResourceDetailUpdate from '../Shared/ResourceDetail/ResourceDetailUpdate';
import InspectionTemplateDetailsForm from './Forms/InspectionTemplateDetailsForm';
// import tenantApi, { Tenant } from '../../utils/api/tenant';

export interface IInspectionTemplateUpdateProps {
  inspectionTemplate: InspectionTemplate;
  onUpdate: () => void;
  projectId?: number;
}

const InspectionTemplateUpdate: React.FC<IInspectionTemplateUpdateProps> = ({
  inspectionTemplate,
  onUpdate,
  projectId,
}) => {
  const [show, setShow] = useState<boolean>(false);
  const [inspectionTypes, setInspectionTypes] = useState<InspectionTemplateType[]>([]);
  const [currentTypeId, setCurrentTypeId] = useState<number | null>(null);
  const [isLoadingTypes, setIsLoadingTypes] = useState<boolean>(false);

  // const [tenants, setTenants] = React.useState<Tenant[]>([]);

  // Re-fetch every time the modal opens so the dropdown always reflects the latest saved type
  useEffect(() => {
    if (!inspectionTemplate.id || !show) return;
    setIsLoadingTypes(true);
    inspectionTemplateTypesApi
      .getAvailableTypes(inspectionTemplate.id, projectId)
      .then(({ types, currentTypeId: fetchedTypeId }) => {
        setInspectionTypes(types);
        setCurrentTypeId(fetchedTypeId);
        setIsLoadingTypes(false);
      })
      .catch((error) => {
        console.error('Error fetching inspection template types:', error);
        setIsLoadingTypes(false);
      });
  }, [inspectionTemplate.id, show, projectId]);

  // useEffect(() => {
  //   tenantApi.index().then((data: Tenant[]) => {
  //     setTenants(data);
  //   });
  // }, []);

  const handleOpenModal = () => {
    setIsLoadingTypes(true);
    setShow(true);
  };

  const handleSubmit = async (formState: any) => {
    try {
      await inspectionTemplateApi.update(inspectionTemplate.id, formState);
      onUpdate();
      setShow(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ResourceDetailUpdate
      resource='Inspection Template'
      onButtonClick={handleOpenModal}
    >
      {show && !isLoadingTypes && (
        <InspectionTemplateDetailsForm
          handleSubmit={handleSubmit}
          handleClose={() => setShow(false)}
          title='Edit Inspection Template'
          inspectionTemplate={{ ...inspectionTemplate, inspection_type_id: currentTypeId } as any}
          inspectionTypes={inspectionTypes}
          // tenants={tenants}
        />
      )}
      {show && isLoadingTypes && (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          Loading inspection types...
        </div>
      )}
    </ResourceDetailUpdate>
  );
};

export default InspectionTemplateUpdate;
